import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const query = `
  mutation (
    $peaceTitleHeading: String,
    $peaceTitle3: String,
    $peaceContent3: String,
    $dynamicWhyHostInfoBlock: String,
) {
  updateWhyHostPage (
    peaceTitleHeading: $peaceTitleHeading,
    peaceTitle3: $peaceTitle3,
    peaceContent3: $peaceContent3,
    dynamicWhyHostInfoBlock: $dynamicWhyHostInfoBlock,
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: {
        peaceTitleHeading: values.dynamicWhyHostInfoBlock[0].peaceTitleHeading,
        peaceTitle3: values.dynamicWhyHostInfoBlock[0].peaceTitle3,
        peaceContent3: values.dynamicWhyHostInfoBlock[0].peaceContent3,
        dynamicWhyHostInfoBlock: JSON.stringify(values.dynamicWhyHostInfoBlock),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
